import { render, staticRenderFns } from "./auth-step-switcher.vue?vue&type=template&id=e1990042&"
import script from "./auth-step-switcher.vue?vue&type=script&lang=js&"
export * from "./auth-step-switcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports